import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
	logUpdate: ["moduleName"],
	setSearchResults: ["searchResults"]
});

export { Creators, Types };
